var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M8.067 2c.267-.352.581-.666.933-.933L8.125.193a.66.66 0 0 0-.932.932L8.067 2zM15.933 2l.874-.875a.66.66 0 0 0-.932-.932L15 1.067c.352.267.666.58.933.933zM1.408 19l-1.2 1.098a.624.624 0 0 0-.208.46v2.79c0 .36.319.652.711.652.393 0 .712-.292.712-.651v-2.52l.577-.53A9.688 9.688 0 0 1 1.408 19zM23.792 20.098L22.592 19A9.75 9.75 0 0 1 22 20.3l.577.529v2.52c0 .36.319.651.712.651.392 0 .711-.292.711-.651v-2.79a.624.624 0 0 0-.208-.46zM19.805 5.211A.78.78 0 0 0 20 4.69V.738C20 .33 19.701 0 19.333 0c-.369 0-.667.33-.667.738v3.646L18 5.12c.38.267.745.56 1.092.88l.713-.789zM7 22.485A8.986 8.986 0 0 0 12 24a8.986 8.986 0 0 0 5-1.515L12 17l-5 5.485zM4.924 6c.342-.316.701-.606 1.076-.87l-.69-.773V.733C5.31.328 5.015 0 4.654 0 4.293 0 4 .328 4 .733V4.66c0 .195.07.382.192.519L4.924 6zM1.214 10.775L4 7.767l-.502-.543a.675.675 0 0 0-1.006 0L.208 9.69a.812.812 0 0 0 0 1.085c.278.3.728.3 1.006 0zM9.796 6.164L12 7.84v8.071l-5.962 5.863a.833.833 0 0 1-1.134.006 9.65 9.65 0 0 1-1.962-2.655A8.83 8.83 0 0 1 2 15.15c0-2.094.729-4.088 2.107-5.767 1.26-1.536 2.954-2.684 4.92-3.34a.843.843 0 0 1 .769.12z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M22 15.15a8.83 8.83 0 0 1-.942 3.975 9.65 9.65 0 0 1-1.962 2.655.833.833 0 0 1-1.134-.006L12 15.91V7.84l2.204-1.676a.843.843 0 0 1 .77-.12c1.965.656 3.659 1.804 4.919 3.34C21.27 11.064 22 13.057 22 15.15zM10.765 4.448L12.5 6l1.735-1.552A1.952 1.952 0 0 1 16 3.995C15.65 2.285 14.214 1 12.5 1S9.35 2.285 9 3.995a1.952 1.952 0 0 1 1.765.453zM22.786 10.775L20 7.767l.502-.543c.278-.299.728-.299 1.006 0l2.284 2.466c.277.3.277.786 0 1.085-.277.3-.728.3-1.006 0z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }